import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router/index'
import { setupPinia } from './stores/index'
import { i18n } from './i18n/index'
import { initUnlockMachine } from './admin/unlockStateMachine'
import './styles/tailwind.css'
import './styles/kiosk.css'

const app = createApp(App)

// Pinia（含持久化插件）
setupPinia(app)

// Vue Router
app.use(router)

// i18n
app.use(i18n)

// F.6 R4 L1：注入路由到解锁状态机（动态路由挂载/卸载）
initUnlockMachine(router)

app.mount('#app')

// ── H5 浏览器外壳注册（用于 CMS 监控） ────────────────────────────────────────
import('@/composables/useShellReport').then(({ useShellReport }) => {
  const { start } = useShellReport()
  start()
}).catch(() => { /* 静默 */ })

// ── F.4 shell_ready 埋点（router ready 后） ──────────────────────────────────
// 注意：useTelemetry 的全局单例在此处启动埋点，WS sender 由外部注入或使用默认
// 记录启动时间（从导航开始到 router ready 完成）
const _appStartMs = Date.now()
router.isReady().then(() => {
  const startupMs = Date.now() - _appStartMs
  // 动态 import 避免 main.ts 启动时模块加载顺序问题
  import('@/composables/useTelemetry').then(({ getTelemetry }) => {
    const telemetry = getTelemetry()
    telemetry.track('shell_ready', {
      kiosk_mode: typeof window !== 'undefined' && '__TAURI__' in window ? 'tauri' : 'h5',
      app_version: import.meta.env.VITE_APP_VERSION ?? '0.0.0',
      startup_ms: startupMs,
    })
  }).catch(() => { /* 静默，不影响应用启动 */ })
}).catch(() => { /* 静默 */ })
